import { Fragment } from 'react'
import { Control, UseFormTrigger, useFieldArray } from 'react-hook-form'
import { Col, Row, Button } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash, faAdd } from '@fortawesome/pro-solid-svg-icons'
import classNames from 'classnames'

import TextInput from 'components/ui/forms/field/text-input/TextInput'
import { useTranslationRankmi } from 'helpers/translations.helper'
import { FormValues } from '../../constants'
import styles from './Panelists.module.scss'

const divider = <hr className="my-2" />

interface PanelistsProps {
  control: Control<FormValues>
  trigger: UseFormTrigger<FormValues>
  disable: boolean
}

export const Panelists = ({ control, trigger, disable }: PanelistsProps) => {
  const { update, fields, append, remove } = useFieldArray({
    name: 'panelists',
    control,
  })

  const tRelative = useTranslationRankmi({
    prefix: 'administration.blocks.type.meeting.panelists',
  })

  return (
    <Row className="mt-3">
      <Col xs={12}>
        <h1 className={styles.title}>{tRelative(`title`)}</h1>
      </Col>
      <Col xs={12} className="mt-2">
        <Row
          className={classNames('font-weight-bold grey-darken', styles.headers)}
        >
          <Col xs={6}>
            <div>{tRelative(`headers.name`)}</div>
          </Col>
          <Col xs={6}>
            <div>{tRelative(`headers.email`)}</div>
          </Col>
        </Row>
        {divider}
        {fields.map((item, index) => {
          const { error: nameError } = control.getFieldState(
            `panelists.${index}.name`
          )
          const { error: emailError } = control.getFieldState(
            `panelists.${index}.email`
          )
          return (
            <Fragment key={index}>
              <Row>
                <Col xs={6}>
                  <TextInput
                    name={'name'}
                    placeHolder={''}
                    value={item.name}
                    onChange={(e) => {
                      update(index, { ...item, ['name']: e.target.value })
                      trigger('panelists')
                    }}
                    isInvalid={!!nameError}
                    disabled={disable}
                  />
                </Col>
                <Col xs={6}>
                  <Row>
                    <Col xs>
                      <TextInput
                        name={'email'}
                        placeHolder={''}
                        value={item.email}
                        onChange={(e) => {
                          update(index, { ...item, ['email']: e.target.value })
                          trigger('panelists')
                        }}
                        error={''}
                        isInvalid={!!emailError}
                        disabled={disable}
                      />
                    </Col>
                    <Col xs="auto">
                      <Button
                        onClick={() => {
                          remove(index)
                        }}
                        variant="light"
                        disabled={index === 0}
                      >
                        <FontAwesomeIcon icon={faTrash} />
                      </Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
              {divider}
            </Fragment>
          )
        })}
        <Button
          onClick={() => {
            append({ name: '', email: '' })
          }}
          variant="primary-text"
          className="d-flex align-items-center"
        >
          <FontAwesomeIcon icon={faAdd} className="mr-2" />
          {tRelative(`add`)}
        </Button>
      </Col>
    </Row>
  )
}

export default Panelists
